var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background bg-dark"},[_c('h3',{staticStyle:{"color":"#fff"}},[_vm._v("Coloured Bubbles")]),_c('h1',{staticStyle:{"color":"#ff6688"}},[_vm._v("Click to view!")]),_c('div',_vm._l((_vm.colors),function(color){return _c('button',{key:color,style:({
        backgroundColor: color,
        width: '40px',
        height: '40px',
        border: 'none',
        borderRadius: '50%',
        margin: '10px',
        cursor: 'pointer',
      }),on:{"click":function($event){return _vm.setRippleColor(color)}}})}),0),_c('div',{staticClass:"background",staticStyle:{"position":"relative","width":"100%","height":"100vh"},attrs:{"id":"rippleapp"},on:{"click":function($event){return _vm.createRipple($event)}}},_vm._l((_vm.ripples),function(ripple){return _c('div',{key:ripple.id,staticClass:"ripple",style:({
        left: `${ripple.x}px`,
        top: `${ripple.y}px`,
        width: `${ripple.size}px`,
        height: `${ripple.size}px`,
        background: ripple.color /* Dynamic ripple color */,
        animation: `ripple-animation 2s ease-out forwards`,
      })})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }